"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.833 11.85h1.334c1.383 0 2.5 1.005 2.5 2.25s-1.117 2.25-2.5 2.25h-1.334v-4.5zm0-4.2h.917c1.15 0 2.083.84 2.083 1.875 0 1.035-.933 1.875-2.083 1.875h-.917V7.65zM7.5 7.2v.45h1c.275 0 .5.203.5.45v7.8c0 .248-.225.45-.5.45h-.833v.45H13.5c1.658 0 3-1.208 3-2.7 0-1.125-.768-2.093-1.86-2.498.717-.428 1.193-1.17 1.193-2.002 0-1.328-1.191-2.4-2.666-2.4H7.5z" }), "Bold");
//# sourceMappingURL=Bold.js.map